<template>
  <div>
    <app-cells>
      <app-button @click.native="onShowFormPopup">Form</app-button>
    </app-cells>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :scrollable="true"
      :width="800"
      class="modal-not-overflow"
      draggable=".popup__title"
      name="form"
    >
      <div class="popup">
        <button class="popup__close" type="button" @click="$modal.hide('form')"></button>
        <div class="popup__title">Form</div>
        <div class="popup__body">
          <app-form
            :form-config="config_form_flight_reservation"
            :form.sync="form_flight_reservation"
            @submit="handleSubmit"
          >
            <template #additional-after>
              <app-form-group label="Sales manager note for the airline" label-for="notes" required>
                <app-textarea
                  v-model="form_flight_reservation.notes"
                  rows="5"
                  placeholder="Write a note"
                  id="notes"
                />
              </app-form-group>
            </template>
          </app-form>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import { getDomesticFlightsSchedulesOriginAvailable, getReservationsSalesStatuses } from '@/http'

export default {
  name: 'TestFormBuilder',
  data() {
    return {
      config_form_flight_reservation: [
        {
          component: 'app-switcher',
          model: 'switcher_flight_search',
          label: 'Search schedule',
          labelLeft: true,
          attrs: {
            id: 'switcher_flight_search'
          },
          grid: {
            row: 1,
            col: 1,
            width: 1
          }
        },
        {
          component: 'app-date-picker',
          model: 'date',
          label: 'Date',
          attrs: {
            format: 'DD MMM YYYY',
            valueType: 'YYYY-MM-DD',
            placeholder: 'Date',
            popupClass: 'datepicker__popup',
            titleFormat: 'DD MMM YYYY',
            clearable: false
          },
          events: {
            input: this.onDateChanged
          },
          validations: {
            required: val => !!val,
            minValue(val) {
              return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
            }
          },
          validationMessages: {
            minValue: 'Date cannot be less than the current date'
          },
          grid: {
            row: 2,
            col: 1,
            width: 1
          }
        },
        {
          component: 'app-select',
          model: 'sales_status',
          label: 'Status',
          attrs: {
            reduce: item => item.code,
            options: [],
            filterable: true,
            clearable: true,
            searchable: true,
            label: 'name',
            placeholder: 'Status',
            readonly: true
          },
          validations: { required: val => !!val },
          grid: {
            row: 2,
            col: 2,
            width: 1
          },
          isHidden: false,
        },
        {
          component: 'app-select',
          model: 'flight_from',
          label: 'Origin',
          attrs: {
            options: [],
            filterable: true,
            clearable: true,
            searchable: true,
            label: 'name',
            placeholder: 'Choose origin',
            readonly: true
          },
          validations: { required: val => !!val },
          grid: {
            row: 3,
            col: 1,
            width: 1
          },
          isHidden: false,
        },
        // {
        //   component: 'app-textarea',
        //   model: 'notes',
        //   label: 'Sales manager note for the airline',
        //   attrs: {
        //     id: 'notes',
        //     rows: '5',
        //     placeholder: 'Write a note'
        //   },
        //   grid: {
        //     row: 4,
        //     col: 1,
        //     width: 1
        //   },
        // }
      ],
      form_flight_reservation: {
        switcher_flight_search: true,
        sales_status: null,
        flight_from: null
      }
    }
  },
  watch: {
    'form_flight_reservation.date'() {
      this.toggleReadonly('sales_status', !this.form_flight_reservation.date)
    },
    'form_flight_reservation.sales_status'() {
      this.toggleReadonly('flight_from', !this.form_flight_reservation.sales_status)
    },
    'form_flight_reservation.switcher_flight_search'(val) {
      this.toggleVisibility('sales_status', !val)
      this.toggleVisibility('flight_from', !val)
    },
  },
  methods: {
    toggleReadonly(model, isReadonly) {
      const field = this.config_form_flight_reservation.find(item => item.model === model)
      if (field && field.attrs) field.attrs.readonly = isReadonly
    },
    toggleVisibility(model, isHidden) {
      const field = this.config_form_flight_reservation.find(item => item.model === model)
      if (field) field.isHidden = isHidden
    },
    onDateChanged() {
      this.form_flight_reservation.flight_from = null
      this.form_flight_reservation.sales_status = null

      getDomesticFlightsSchedulesOriginAvailable({ date: this.form_flight_reservation.date })
        .then(res => {
          this.config_form_flight_reservation.find(item => item.model === 'flight_from').attrs.options = res.data
        })
    },
    handleSubmit(formData) {
      console.log(formData)
    },
    onShowFormPopup() {
      getReservationsSalesStatuses({ flights_create: true })
        .then(res => {
          this.config_form_flight_reservation.find(item => item.model === 'sales_status').attrs.options = res.data
          this.$modal.show('form')
        })
    }
  }
}
</script>